import * as cn from 'classnames'
import * as styles from 'styles/pages/Styleguide.css'
import { PageHeading, SmallHeading, ExternalPageHeading, ModuleTitle, BodyText, Caption } from 'components/atoms/Text'

const SGTextStyles = () => (
  <section className={ cn(styles.sgSection, styles.typeStyles) }>
    <div>
      <PageHeading>
        Your spending in <span>All Categories</span> over the <span>last 6 months</span>
      </PageHeading>
      <Caption text='headline-medium' />
    </div>

    <div>
      <SmallHeading text='Blended with organic milk — New orleans iced coffee' />
      <Caption text='headline-small' />
    </div>

    <div>
      <ExternalPageHeading>External page title</ExternalPageHeading>
    </div>

    <div>
      <ModuleTitle text='Net Worh & Debts' />
      <Caption text='deck' />
    </div>

    <div>
      <BodyText text='Bacon ipsum dolor amet shank pork chop jowl <a>frankfurter</a> andouille short ribs bresaola ribeye porchetta tail drumstick kevin bacon flank turducken.' />
      <Caption text='body' />
    </div>
  </section>
)

export default SGTextStyles

